import { render, staticRenderFns } from "./payment-info.vue?vue&type=template&id=3cc5145f"
import script from "./payment-info.vue?vue&type=script&lang=js"
export * from "./payment-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports